module.exports = __webpack_public_path__ + "img/game_main_pc_22_off.222a2192.png";